module.exports = __webpack_public_path__ + "img/532.afe01c76.jpg";